import { ReportsMeta, ReportsQueries } from "store/types";

export default (meta: ReportsMeta, stateQueries: ReportsQueries): ReportsQueries => {
  const { measures } = meta;

  // Update hardcoded measures with existing from the API if need
  const queriesMeasures = stateQueries.measures.map((item, index) =>
    measures.includes(item) ? item : measures[index]
  );

  // Update hardcoded graphs measures values
  const updateGraphQueries = stateQueries.graphDataFormation;
  for (const chartKey in updateGraphQueries) {
    const { measure } = updateGraphQueries[chartKey];

    if (!measures.length && !measures.includes(measure) && !measure.startsWith("calc-field-")) {
      updateGraphQueries[chartKey] = { ...updateGraphQueries[chartKey], measure: measures[0] };
    }
  }

  return {
    ...stateQueries,
    measures: queriesMeasures,
    graphDataFormation: updateGraphQueries
  };
};
